import React from 'react'
import cn from 'classnames'
import PinIcon from 'components/PinIcon'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Flex, Divider } from 'shared/ui'

import { translate } from './util'
import Count from './Count'
import FilterBar from './FilterBar'
import SortMenu from './SortMenu'
import styles from './styles.less'

const Narrow = ({
  canSeePinnedSearches,
  isFreeFormSearch,
  isSearchPinnable,
  isSelectionMode,
  onPinUnpinClick,
  pinnedSearch,
  searchIsFolderSearch,
  title,
  titleType,
}) => {
  const getTitleLabel = () => {
    if (isFreeFormSearch) return 'Search results'
    if (searchIsFolderSearch) return title
    return translate(title)
  }

  const titleComponent = (
    <div
      className={cn(styles.title, {
        [styles.bulk]: isSelectionMode,
      })}
    >
      <Flex noOverflow alignItems="baseline">
        <span
          className={cn(styles.titleLabel, styles.ellipsis)}
          css={`
            font-family: ${themeVars.pageFont};
            font-weight: ${themeVars.pageFontWeightSemiBold};
          `}
        >
          {getTitleLabel()}
        </span>
        <Count />
      </Flex>
    </div>
  )

  return (
    <div className={styles.TicketListHeader}>
      <div className={styles.top}>
        <div className={styles.topCenter}>{titleComponent}</div>
        <Flex className={styles.topRight}>
          {canSeePinnedSearches &&
            isSearchPinnable && (
              <React.Fragment>
                <PinIcon
                  size="small"
                  enabled={!isSelectionMode}
                  isPinned={!!pinnedSearch}
                  onPinClick={onPinUnpinClick}
                />
                <Divider ml={2} mt="2px" vertical size="small" />
              </React.Fragment>
            )}
          <SortMenu ml={2} />
        </Flex>
      </div>

      <FilterBar
        searchIsFolderSearch={searchIsFolderSearch}
        titleType={titleType}
      />
    </div>
  )
}

export default Narrow
